import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useMemo } from 'react';

import {
  Box,
  VStack,
  HStack,
  Input,
  Button,
  Text,
  Divider,
  SimpleGrid,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Heading,
  Td,
  Tr,
  Tbody,
  Table,
  Th,
  Thead,
  useToast,
  Spinner,
} from '@chakra-ui/react';
import { Select as ChakraSelect } from '@chakra-ui/react';

import axios from 'axios';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
type OptionType = {
  value: string;
  label: string;
};

type ConceptoOption = {
  value: string; // El tipo debe coincidir con `id` de tu catálogo
  label: string; // El texto que se mostrará
};

interface Concepto {
  claveProdServ: string;
  claveUnidad: string;
  cantidad: string;
  unidad: string;
  descripcion: string;
  valorUnitario: string;
  importe: string;
  NoIdentificacion: string;
  conceptoId: string;
  objImp: string;
  objetoImp: string;
  descuento: string;
  tipoDescuento: string;
}

interface Comprobante {
  claveCatastralEstandar: string;
  paraje: string;
  cUsoDestino: string;
  receptorRegimenFiscal: string;
  receptorUsoCFDI: string;
  receptorDomicilioFiscal: string;
  receptorNombre: string;
  RFCReceptor: string;
  serie: string;
  folio: string;
  formaPago: string;
  moneda: string;
  metodoPago: string;
  lugarExpedicion: string;
  idCatas: string;
  domicilio: string;
  conceptos: Concepto[];
}

// JSON de los catálogos del SAT
const catalogosSAT = {
  moneda: [
    { clave: 'MXN', descripcion: 'Peso Mexicano' },
    { clave: 'USD', descripcion: 'Dólar Americano' },
  ],
  formaPago: [
    { value: '01', label: 'Efectivo' },
    { value: '02', label: 'Cheque nominativo' },
    { value: '03', label: 'Transferencia electrónica' },
    { value: '04', label: 'Tarjeta de crédito' },
    { value: '05', label: 'Monedero electrónico' },
    { value: '06', label: 'Dinero electrónico' },
    { value: '08', label: 'Vales de despensa' },
    { value: '12', label: 'Dación en pago' },
    { value: '13', label: 'Pago por subrogación' },
    { value: '14', label: 'Pago por consignación' },
    { value: '15', label: 'Condonación' },
    { value: '17', label: 'Compensación' },
    { value: '23', label: 'Novación' },
    { value: '24', label: 'Confusión' },
    { value: '25', label: 'Remisión de deuda' },
    { value: '26', label: 'Prescripción o caducidad' },
    { value: '27', label: 'A satisfacción del acreedor' },
    { value: '28', label: 'Tarjeta de débito' },
    { value: '29', label: 'Tarjeta de servicios' },
    { value: '30', label: 'Aplicación de anticipos' },
    { value: '31', label: 'Intermediario pagos' },
    { value: '99', label: 'Por definir' },
  ],

  usosCFDI: [
    { value: 'S01', label: 'Sin Efectos Fiscales' },

    { value: 'G01', label: 'Adquisición de mercancías' },
    { value: 'G02', label: 'Devoluciones, descuentos o bonificaciones' },
    { value: 'G03', label: 'Gastos en general' },
    { value: 'I01', label: 'Construcciones' },
    { value: 'I02', label: 'Mobiliario y equipo de oficina por inversiones' },
    { value: 'I03', label: 'Equipo de transporte' },
    { value: 'I04', label: 'Equipo de cómputo y accesorios' },
    { value: 'I05', label: 'Dados, troqueles, moldes, matrices y herramental' },
    { value: 'I06', label: 'Comunicaciones telefónicas' },
    { value: 'I07', label: 'Comunicaciones satelitales' },
    { value: 'I08', label: 'Otra maquinaria y equipo' },
    {
      value: 'D01',
      label: 'Honorarios médicos, dentales y gastos hospitalarios',
    },
    { value: 'D02', label: 'Gastos médicos por incapacidad o discapacidad' },
    { value: 'D03', label: 'Gastos funerales' },
    { value: 'D04', label: 'Donativos' },
    {
      value: 'D05',
      label: 'Intereses reales efectivamente pagados por créditos hipotecarios',
    },
    { value: 'D06', label: 'Aportaciones voluntarias al SAR' },
    { value: 'D07', label: 'Primas por seguros de gastos médicos' },
    { value: 'D08', label: 'Gastos de transportación escolar obligatoria' },
    {
      value: 'D09',
      label:
        'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones',
    },
    { value: 'D10', label: 'Pagos por servicios educativos (colegiaturas)' },
    { value: 'P01', label: 'Por definir' },
  ],

  regimenesFiscales: [
    { value: '601', label: 'General de Ley Personas Morales' },
    { value: '603', label: 'Personas Morales con Fines no Lucrativos' },
    {
      value: '605',
      label: 'Sueldos y Salarios e Ingresos Asimilados a Salarios',
    },
    { value: '606', label: 'Arrendamiento' },
    { value: '607', label: 'Régimen de Enajenación o Adquisición de Bienes' },
    { value: '608', label: 'Demás ingresos' },
    { value: '609', label: 'Consolidación' },
    {
      value: '610',
      label:
        'Residentes en el Extranjero sin Establecimiento Permanente en México',
    },
    { value: '611', label: 'Ingresos por Dividendos (socios y accionistas)' },
    {
      value: '612',
      label: 'Personas Físicas con Actividades Empresariales y Profesionales',
    },
    { value: '614', label: 'Ingresos por intereses' },
    { value: '615', label: 'Régimen de los ingresos por obtención de premios' },
    { value: '616', label: 'Sin obligaciones fiscales' },
    {
      value: '620',
      label:
        'Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
    },
    { value: '621', label: 'Incorporación Fiscal' },
    {
      value: '622',
      label: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
    },
    { value: '623', label: 'Opcional para Grupos de Sociedades' },
    { value: '624', label: 'Coordinados' },
    {
      value: '625',
      label:
        'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
    },
    { value: '626', label: 'Régimen Simplificado de Confianza' },
  ],

  ProdServicio: [
    { value: '80111700', label: 'Servicios de subcontratación de personal' },
    { value: '10101501', label: 'Gatos vivos' },
    { value: '93161700', label: 'Generico' },
    { value: '10101700', label: 'Caballos y mulas' },
    { value: '10101801', label: 'Aves vivas' },
    { value: '10101904', label: 'Peces ornamentales' },
    {
      value: '20121703',
      label: 'Aceites y grasas para propósitos industriales',
    },
    { value: '20131800', label: 'Solventes industriales' },
    { value: '30101700', label: 'Medicamentos de venta con receta' },
    { value: '30102102', label: 'Vacunas humanas' },
    { value: '40151503', label: 'Materiales aislantes' },
    { value: '43211800', label: 'Computadoras personales' },
    { value: '43211708', label: 'Servidores' },
    { value: '43211508', label: 'Impresoras' },
    { value: '44103103', label: 'Cuadernos' },
    { value: '44122008', label: 'Bolígrafos y plumas' },
    { value: '50101703', label: 'Ropa interior femenina' },
    { value: '50101707', label: 'Ropa interior masculina' },
    { value: '60101000', label: 'Equipo deportivo' },
    { value: '70131501', label: 'Muebles de oficina' },
    { value: '80111613', label: 'Servicios de limpieza de oficinas' },
    { value: '85121620', label: 'Servicios de transporte terrestre' },
    { value: '93142105', label: 'Servicios de asesoramiento financiero' },
    { value: '93142106', label: 'Servicios de auditoría contable' },
    { value: '93142204', label: 'Consultoría jurídica' },
    { value: '95111600', label: 'Electricidad' },
    { value: '95121705', label: 'Servicios de agua potable' },
    { value: '12161501', label: 'Combustibles fósiles' },
    { value: '14111500', label: 'Minerales metálicos' },
    { value: '15121503', label: 'Lubricantes' },
    { value: '25171700', label: 'Tubos y accesorios' },
    { value: '26101604', label: 'Baterías de automóviles' },
    { value: '30191800', label: 'Ropa de hospital' },
    { value: '30211905', label: 'Equipo quirúrgico' },
    { value: '43212202', label: 'Cables de red' },
    { value: '43232907', label: 'Aplicaciones de software contable' },
    { value: '52161500', label: 'Herramientas de construcción' },
  ],

  ClaveUnidad: [
    { value: 'E48', label: 'Unidad de servicio' },
    { value: 'H87', label: 'Pieza' },
    { value: 'KGM', label: 'Kilogramo' },
    { value: 'LTR', label: 'Litro' },
    { value: 'MTR', label: 'Metro' },
  ],
  metodoPago: [
    { value: 'PUE', label: 'Pago en una sola exhibición' },
    { value: 'PPD', label: 'Pago en parcialidades o diferido' },
  ],
};

interface PropietarioData {
  id: string;
  nombre: string;
  primerApellido: string;
  segundoApellido?: string;
  rfc?: string;
  telefono?: string;
  esTitular: boolean;
}

interface Colindancia {
  id: string;
  idClaveCatastral: string;
  nombre: string;
  primerApellido: string;
  segundoApellido: string;
  orientacion: string;
  descripcion: string;
  longitud: string;
}
interface PredioData {
  idClaveCatastral: string;
  calle: string;

  numeroExterior: string;
  numeroInterior?: string;
  letra?: string;
  colonia: string;
  poblacion: string;
  paraje?: string;
  denominacion?: string;
  nivelesConstruidos: number;
  nivelesSubterraneos: number;
  fechaAlta: string;
  observaciones?: string;
  codigoPostal: number;
  ciudad: string;
  indiviso: string;
  frente: string;
  fondo: string;
  edificio: number;
  nivel: number;
  areaConsPrivativa: string;
  areaConsComun: string;
  areaConsTotal: string;
  areaTerrPrivativa: string;
  areaTerrComun: string;
  areaTerrTotal: string;
  areaTerrCarto: string;
  fechaActualizacion: string;
  usuario: string;
  origenMovimiento?: string;
  cuentaOrigen?: string;
  fechaOperacion?: string;
  cEstadoFisico: { descripcion: string };
  ClaveCatastral: {
    claveCatastralEstandar: string;
    Colindancias: [Colindancia];
    cTipoPredio: { descripcion: string };

    PropietarioPredio: [
      {
        Propietario: PropietarioData;
      },
    ];
  };

  cRegimenPropiedad: { descripcion: string };
  cTenencia: { descripcion: string };
  cZonaValor: { descripcion: string };
  cTipoPosesion: { descripcion: string };
  cUsoDestino: { descripcion: string };
  ServiciosInspeccion?: { idInspeccion: number };
}
interface HistorialPagosProps {
  idClaveCatastral: string;
  pagoid: string;
  monto: number;
  data: PredioData;
  onClose: () => void;
  conceptoInicial?: string;
  montoInicial?: number;
}
const FacturacionComponent: React.FC<HistorialPagosProps> = ({
  idClaveCatastral,
  pagoid,
  data,
  monto,
  onClose,
  conceptoInicial,
  montoInicial,
}) => {

  const user = useSelector((state: RootState) => state.auth.user);

  // Función para obtener el concepto basado en el tipo de predio
  const getConceptoId = (tipoPredioDatos: string, catalogoConceptos: any[]) => {
    if (tipoPredioDatos?.includes('URBANO')) {
      return catalogoConceptos.find(c => c.descripcion?.includes('URBANO'))?.id?.toString() || '';
    } else if (tipoPredioDatos?.includes('RUSTICO')) {
      return catalogoConceptos.find(c => c.descripcion?.includes('RUSTICO'))?.id?.toString() || '';
    }
    return '';
  };

  const [comprobante, setComprobante] = useState<Comprobante>({
    receptorRegimenFiscal: '616',
    domicilio:'',
    receptorUsoCFDI: 'S01',
    receptorDomicilioFiscal: '90160',
    receptorNombre:
      data.ClaveCatastral.PropietarioPredio[0].Propietario.nombre +
      ' ' +
      data.ClaveCatastral.PropietarioPredio[0].Propietario.primerApellido +
      ' ' +
      data.ClaveCatastral.PropietarioPredio[0].Propietario.segundoApellido,
      RFCReceptor:
      data.ClaveCatastral.PropietarioPredio[0].Propietario.rfc.trim() === '' 
        ? 'XAXX010101000' 
        : data.ClaveCatastral.PropietarioPredio[0].Propietario.rfc,
    
      idCatas: idClaveCatastral,
    serie: '',
    folio: '',
    formaPago: '01',
    moneda: 'MXN',
    metodoPago: 'PUE',
    lugarExpedicion: '90160',
    paraje: data.paraje,
    cUsoDestino: data.ClaveCatastral.cTipoPredio.descripcion,
    claveCatastralEstandar: data.ClaveCatastral.claveCatastralEstandar,
    conceptos: [
      {
        claveProdServ: '93161700',
        claveUnidad: 'E48',
        cantidad: '1',
        NoIdentificacion: '4.1.1.2.2',
        objImp: '02',
        unidad: 'SERVICIO',
        descripcion: `${conceptoInicial || data.ClaveCatastral.cTipoPredio.descripcion} PAGO DEL IMPUESTO PREDIAL`,
        valorUnitario: (montoInicial || monto).toString(),
        importe: (montoInicial || monto).toString(),
        objetoImp: '',
        tipoDescuento: '',
        descuento: '',
        conceptoId: '',
      },
    ],
  });
  const [tipoDescuentoCatalogo, setTipoDescuentoCatalogo] = useState([]);
  const [conceptosCatalogo, setConceptosCatalogo] = useState([]);
  const toast = useToast();
  const [loading, setLoading] = useState(false); // Estado para bloquear pantalla

  useEffect(() => {
    fetch('https://facturacion-totolac.togui.com.mx/api/cTipoDescuentoRoutes')
      .then((response) => response.json())
      .then((data) => setTipoDescuentoCatalogo(data))
      .catch((error) =>
        console.error('Error al cargar el catálogo de descuentos:', error),
      );

    fetch('https://facturacion-totolac.togui.com.mx/api/cConceptoSolicitudRoutes')
      .then((response) => response.json())
      .then((data) => {
        setConceptosCatalogo(data);
        
        // Auto-seleccionar concepto si viene conceptoInicial
        if (conceptoInicial && data.length > 0) {
          const conceptoId = getConceptoId(conceptoInicial, data);
          const conceptoEncontrado = data.find((c: any) => c.id.toString() === conceptoId);
          
          if (conceptoEncontrado) {
            setComprobante(prev => ({
              ...prev,
              conceptos: prev.conceptos.map((concepto, index) => 
                index === 0 ? {
                  ...concepto,
                  conceptoId: conceptoEncontrado.id.toString(),
                  descripcion: `${conceptoInicial.includes('URBANO') ? 'URBANO' : 'RUSTICO'} PAGO DEL IMPUESTO PREDIAL`,
                  NoIdentificacion: conceptoEncontrado.cuentaContable
                } : concepto
              )
            }));
          }
        }
      })
      .catch((error) =>
        console.error('Error al cargar el catálogo de conceptos:', error),
      );
  }, [conceptoInicial]);
  const handleInputChange = (field: keyof Comprobante, value: string) => {
    setComprobante({ ...comprobante, [field]: value });
  };

  const handleConceptoChange = (
    index: number,
    field: keyof Concepto,
    value: string,
  ) => {
    const conceptos = [...comprobante.conceptos];
    conceptos[index][field] = value;
    setComprobante({ ...comprobante, conceptos });
  };

  const addConcepto = () => {
    setComprobante({
      ...comprobante,
      conceptos: [
        ...comprobante.conceptos,
        {
          NoIdentificacion: '',
          objImp: '02',
          claveProdServ: '',
          claveUnidad: '',
          cantidad: '',
          unidad: '',
          descripcion: '',
          valorUnitario: '',
          importe: '',
          objetoImp: '',
          tipoDescuento: '',
          descuento: '',
          conceptoId: '',
        },
      ],
    });
  };

  const removeConcepto = (index: number) => {
    const conceptos = [...comprobante.conceptos];
    conceptos.splice(index, 1);
    setComprobante({ ...comprobante, conceptos });
  };

  type ConceptoOption = {
    value: string; // El tipo debe coincidir con el ID de los conceptos (puede ser `string` o `number`)
    label: string; // El texto que se muestra en el dropdown
    cuentaContable:string

  };

  const conceptoOptions: ConceptoOption[] = conceptosCatalogo.map((item) => ({
    value: item.id.toString(), // Convierte `id` a string si es un número
    label: item.descripcion,
    cuentaContable: item.cuentaContable

  }));

  const cerrar = async () => {
    
  }

  const facturar = async () => {
    // onFacturarOpen();
    //await axios.post(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/Transaccion", comprobante);
    setLoading(true)
    const toastId = toast({
      title: 'Generando archivo...',
      description: 'Por favor espera mientras generamos el pago.',
      status: 'info',
      duration: null, // Mantener hasta que se cierre manualmente
      isClosable: true,
    });

    try {
      //console.log(comprobante);
      const Comprobantex = {
        ...comprobante,
        usuario: user.name
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/Transacciones`,
        Comprobantex,
        {
          responseType: 'blob',
        },
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: 'application/pdf' }),
      );
      window.open(url, '_blank');

      // const link = document.createElement('a');
      // link.href = url;
      // link.setAttribute('download', `Pago_${idClaveCatastral}.pdf`);
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      toast.close(toastId);

      toast({
        title: 'Éxito',
        description: 'El pago se generó y descargó correctamente.',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });

      onClose()
    } catch (error) {
      console.error('Error al generar el manifiesto:', error);
      alert('No se pu do generar el pago. Inténtalo de nuevo.');
    }finally {
      setLoading(false)
    }
  };

  return (
    <Box p={8} bg="gray.50" borderRadius="md" boxShadow="md" mx="auto">
      {loading && (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100vw"
        height="100vh"
        bg="rgba(0, 0, 0, 0.5)"
        display="flex"
        justifyContent="center"
        alignItems="center"
        zIndex="9999"
      >
        <Spinner size="xl" color="white" />
      </Box>
    )}
      <Text fontSize="xl" fontWeight="bold" mb={4}>
        Generación de Pago Manual
      </Text>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
        {/* <Input
    placeholder="Serie"
    value={comprobante.serie}
    onChange={(e) => handleInputChange('serie', e.target.value)}
  />
  <Input
    placeholder="Folio"
    value={comprobante.folio}
    onChange={(e) => handleInputChange('folio', e.target.value)}
  /> */}
        <Input
          placeholder="RFC Receptor"
          value={comprobante.RFCReceptor}
          onChange={(e) => handleInputChange('RFCReceptor', e.target.value)}
         isRequired
        />
        <Input
          placeholder="Domicilio"
          value={comprobante.domicilio}
          onChange={(e) => handleInputChange('domicilio', e.target.value)}
        />

        <Input
          placeholder="Nombre Receptor"
          value={comprobante.receptorNombre}
          onChange={(e) => handleInputChange('receptorNombre', e.target.value)}
        />
        <Input
          placeholder="Domicilio Fiscal Receptor"
          value={comprobante.receptorDomicilioFiscal}
          onChange={(e) =>
            handleInputChange('receptorDomicilioFiscal', e.target.value)
          }
        />
        <ChakraSelect
          placeholder="Régimen Fiscal Receptor"
          value={comprobante.receptorRegimenFiscal}
          onChange={(e) =>
            handleInputChange('receptorRegimenFiscal', e.target.value)
          }
        >
          {catalogosSAT.regimenesFiscales.map((item: any) => (
            <option key={item.value} value={item.value}>
              {item.value} - {item.label}
            </option>
          ))}
        </ChakraSelect>
        <ChakraSelect
          placeholder="Uso CFDI"
          value={comprobante.receptorUsoCFDI}
          onChange={(e) => handleInputChange('receptorUsoCFDI', e.target.value)}
        >
          {catalogosSAT.usosCFDI.map((item: any) => (
            <option key={item.value} value={item.value}>
              {item.value} - {item.label}
            </option>
          ))}
        </ChakraSelect>
        <ChakraSelect
          placeholder="Forma de Pago"
          value={comprobante.formaPago}
          onChange={(e) => handleInputChange('formaPago', e.target.value)}
        >
          {catalogosSAT.formaPago.map((item: any) => (
            <option key={item.value} value={item.value}>
              {item.value} - {item.label}
            </option>
          ))}
        </ChakraSelect>
        <ChakraSelect
          placeholder="Moneda"
          value={comprobante.moneda}
          onChange={(e) => handleInputChange('moneda', e.target.value)}
        >
          {catalogosSAT.moneda.map((item: any) => (
            <option key={item.clave} value={item.clave}>
              {item.descripcion}
            </option>
          ))}
        </ChakraSelect>
        <ChakraSelect
          placeholder="Método de Pago"
          value={comprobante.metodoPago}
          onChange={(e) => handleInputChange('metodoPago', e.target.value)}
        >
          {catalogosSAT.metodoPago.map((item: any) => (
            <option key={item.value} value={item.value}>
              {item.value} - {item.label}
            </option>
          ))}
        </ChakraSelect>
        <Input
          placeholder="Lugar de Expedición"
          value={comprobante.lugarExpedicion}
          onChange={(e) => handleInputChange('lugarExpedicion', e.target.value)}
        />
      </SimpleGrid>

      <Divider my={6} />
      <Box
        bg="gray.50"
        borderRadius="md"
        boxShadow="md"
        maxW="1200px"
        mx="auto"
      >
        <Heading as="h2" size="lg" color="#5b182b" mb={6} textAlign="center">
          Detalles del Predio
        </Heading>
        <SimpleGrid columns={3} spacing={4}>
          {/* Clave Catastral */}
          <Input
            disabled
            placeholder="Clave Catastral Estandar"
            value={data.ClaveCatastral.claveCatastralEstandar}
            onChange={(e) =>
              handleInputChange('claveCatastralEstandar', e.target.value)
            }
          />

          {/* Ubicación o Paraje */}
          <Input
            disabled
            placeholder="Ubicación o Paraje"
            value={data.paraje || ''}
            onChange={(e) => handleInputChange('paraje', e.target.value)}
          />

          {/* Tipo de Predio */}

          <Input
            disabled
            placeholder="Ubicación o Paraje"
            value={data.ClaveCatastral.cTipoPredio.descripcion || ''}
            onChange={(e) => handleInputChange('cUsoDestino', e.target.value)}
          />
          {/* <ChakraSelect
          placeholder="Seleccione el Tipo de Predio"
          value={data.ClaveCatastral.cTipoPredio.descripcion}
          onChange={(e) => handleInputChange("cUsoDestino", e.target.value)}
        >
          <option value="Rústico">Rústico</option>
          <option value="Urbano">Urbano</option>
        </ChakraSelect> */}

          {/* Paraje */}
     
        </SimpleGrid>
      </Box>
      <Divider my={3} />

      <Text fontSize="lg" fontWeight="bold" mb={4}>
        Conceptos
      </Text>

      <Box overflowX="auto" height={'2xs'}>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Concepto</Th>
              <Th>Clave</Th>
              <Th>Clave Unidad</Th>
              <Th>Cantidad</Th>
              <Th>Unidad</Th>
              <Th>ObjImp</Th>
              <Th>Descripción</Th>
              <Th>Valor Unitario</Th>
              <Th>Tipo de Descuento</Th>
              <Th>% de Descuento</Th>
              <Th>Importe</Th>
              <Th>Acciones</Th>
            </Tr>
          </Thead>
          <Tbody>
            {comprobante.conceptos.map((concepto, index) => (
              <Tr key={index}>
              <Td>
  <Select
    options={conceptoOptions.sort((a, b) =>
      a.label.localeCompare(b.label, 'es', {
        sensitivity: 'base',
      }),
    )} // Opciones ordenadas alfabéticamente
    value={
      concepto.conceptoId
        ? conceptoOptions.find(
            (option) =>
              option.value === concepto.conceptoId.toString(),
          )
        : null
    }
    onChange={(selectedOption: ConceptoOption | null) => {
      handleConceptoChange(
        index,
        'conceptoId',
        selectedOption?.value || '',
      );
      handleConceptoChange(
        index,
        'descripcion',
        selectedOption?.label || '',
      );
      handleConceptoChange(
        index,
        'NoIdentificacion',
        selectedOption?.cuentaContable || '',
      );
    }}
    isClearable // Permite borrar la selección
    isSearchable // Habilita la búsqueda
    placeholder="Buscar concepto..."
    menuPortalTarget={document.body} // Renderiza el menú fuera del flujo normal
    styles={{
      container: (base: any) => ({
        ...base,
        width: '300px',
        zIndex: 100, // Asegura visibilidad
      }),
      menu: (base: any) => ({
        ...base,
        maxHeight: '150px',
        overflowY: 'auto',
        zIndex: 9999, // Muy alto para sobreponerse
      }),
      menuPortal: (base: any) => ({
        ...base,
        zIndex: 9999,
      }),
    }}
  />
</Td>

                <Td>
                  <ChakraSelect
                    placeholder="Clave"
                    value={concepto.claveProdServ}
                    onChange={(e) =>
                      handleConceptoChange(
                        index,
                        'claveProdServ',
                        e.target.value,
                      )
                    }
                    style={{ width: '180px' }}
                  >
                    {catalogosSAT.ProdServicio.map((item: any) => (
                      <option key={item.value} value={item.value}>
                        {item.value} - {item.label}
                      </option>
                    ))}
                  </ChakraSelect>
                </Td>
                <Td>
                  <ChakraSelect
                    placeholder="Clave Unidad"
                    value={concepto.claveUnidad}
                    onChange={(e) =>
                      handleConceptoChange(index, 'claveUnidad', e.target.value)
                    }
                    style={{ width: '180px' }}
                  >
                    {catalogosSAT.ClaveUnidad.map((item: any) => (
                      <option key={item.value} value={item.value}>
                        {item.value} - {item.label}
                      </option>
                    ))}
                  </ChakraSelect>
                </Td>
                <Td>
                  <Input
                    placeholder="Cantidad"
                    type="number"
                    value={concepto.cantidad}
                    onChange={(e) => {
                      const cantidad = parseFloat(e.target.value) || 0;
                      const valorUnitario =
                        parseFloat(concepto.valorUnitario) || 0;
                      const descuento = parseFloat(concepto.descuento) || 0;
                      const importe =
                        cantidad * valorUnitario * (1 - descuento / 100);
                      handleConceptoChange(
                        index,
                        'cantidad',
                        cantidad.toString(),
                      );
                      handleConceptoChange(
                        index,
                        'importe',
                        importe.toFixed(2),
                      );
                    }}
                    style={{ width: '80px' }}
                  />
                </Td>
                <Td>
                  <Input
                    placeholder="Unidad"
                    value={concepto.unidad}
                    onChange={(e) =>
                      handleConceptoChange(index, 'unidad', e.target.value)
                    }
                    style={{ width: '120px' }}
                  />
                </Td>
                <Td>
                  <Input
                    placeholder="ObjImp"
                    value={concepto.objImp}
                    onChange={(e) =>
                      handleConceptoChange(index, 'objImp', e.target.value)
                    }
                    style={{ width: '70px' }}
                    isDisabled
                  />
                </Td>
                <Td>
                  <Input
                    placeholder="Descripción"
                    value={concepto.descripcion}
                    onChange={(e) =>
                      handleConceptoChange(index, 'descripcion', e.target.value)
                    }
                    style={{ width: '280px' }}
                  />
                </Td>
                <Td>
                  <Input
                    placeholder="Valor Unitario"
                    type="number"
                    value={concepto.valorUnitario}
                    onChange={(e) => {
                      const valorUnitario = parseFloat(e.target.value) || 0;
                      const cantidad = parseFloat(concepto.cantidad) || 0;
                      const descuento = parseFloat(concepto.descuento) || 0;
                      const importe =
                        cantidad * valorUnitario * (1 - descuento / 100);
                      handleConceptoChange(
                        index,
                        'valorUnitario',
                        valorUnitario.toString(),
                      );
                      handleConceptoChange(
                        index,
                        'importe',
                        importe.toFixed(2),
                      );
                    }}
                    style={{ width: '100px' }}
                  />
                </Td>
                <Td>
                  <ChakraSelect
                    placeholder="Tipo de Descuento"
                    value={concepto.tipoDescuento}
                    onChange={(e) =>
                      handleConceptoChange(
                        index,
                        'tipoDescuento',
                        e.target.value,
                      )
                    }
                    style={{ width: '150px' }}
                  >
                    {tipoDescuentoCatalogo.map((descuento: any) => (
                      <option key={descuento.id} value={descuento.id}>
                        {descuento.descripcion}
                      </option>
                    ))}
                  </ChakraSelect>
                </Td>
                <Td>
                  <Input
                    placeholder="% de Descuento"
                    type="number"
                    value={concepto.descuento}
                    onChange={(e) => {
                      const descuento = parseFloat(e.target.value) || 0;
                      const cantidad = parseFloat(concepto.cantidad) || 0;
                      const valorUnitario =
                        parseFloat(concepto.valorUnitario) || 0;
                      const importe =
                        cantidad * valorUnitario * (1 - descuento / 100);
                      handleConceptoChange(
                        index,
                        'descuento',
                        descuento.toString(),
                      );
                      handleConceptoChange(
                        index,
                        'importe',
                        importe.toFixed(2),
                      );
                    }}
                    style={{ width: '80px' }}
                  />
                </Td>
                <Td>
                  <Input
                    placeholder="Importe"
                    type="number"
                    value={concepto.importe}
                    readOnly
                    style={{ width: '100px' }}
                  />
                </Td>
                <Td>
                  <Button
                    bg="#681a2d"
                    color="white"
                    _hover={{ bg: "#5b182b" }}
                    size="sm"
                    onClick={() => removeConcepto(index)}
                  >
                    Eliminar
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      <Button mt={4} bg="#bb8c52" color="white" _hover={{ bg: "#a67a47" }} onClick={addConcepto}>
        Agregar Concepto
      </Button>

      <Divider my={6} />

      <Box display="flex" justifyContent="flex-end" alignItems="center">
        <Box mr={4}>
          <Text fontWeight="bold" fontSize="lg">
            Total: $
            {comprobante.conceptos
              .reduce(
                (sum, concepto) =>
                  sum + (parseFloat(concepto.importe || '0') || 0),
                0,
              )
              .toFixed(2)}
          </Text>
        </Box>
        <Button size="lg" bg="#5b182b" color="white" _hover={{ bg: "#691f30" }} onClick={facturar}>
          Generar y Guardar Pago
        </Button>
          {/* <Button bg="#bb8c52" color="white" _hover={{ bg: "#a67a47" }} onClick={onClose}>
        Cerrar
      </Button> */}
      </Box>
    </Box>
  );
};

export default FacturacionComponent;
function toast(arg0: {
  title: string;
  description: string;
  status: string;
  duration: number;
  isClosable: boolean;
}) {
  throw new Error('Function not implemented.');
}
